/**
 * Colors_T34.jsx
 * Identity for B2C Template 34 — "Horizon" Theme
 * Vibrant Coral / Deep Navy / Sky Blue palette. Clean, modern, coastal.
 */
import { getLocalLogoUrl } from '../../Common/Utils/companyLogo';
export const mapB2CTenantToLanding = (tenantData) => {
  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId,
    logoUrl:         getLocalLogoUrl(tenantData?.domain),
    brandName:       tenantData?.branding?.brandName    || 'Horizon Travels',
    email:           tenantData?.branding?.email        || 'support@horizontravels.com',

    phones:          Array.isArray(tenantData?.branding?.phones)
                     ? tenantData?.branding?.phones[0]
                     : tenantData?.branding?.phones || '9177656344',

    whatsapp:        tenantData?.branding?.whatsapp     || '9177656344',
    socials:         tenantData?.branding?.socials      || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

    themeColor1:     tenantData?.theme?.themeColor1,
    themeColor2:     tenantData?.theme?.themeColor2,
    themeColor3:     tenantData?.theme?.themeColor3,
    themeColor4:     tenantData?.theme?.themeColor4,
    themeColor5:     tenantData?.theme?.themeColor5,

    headerBgOverride:   tenantData?.header?.bgColor,
    headerTextOverride: tenantData?.header?.textColor,
    footerBgOverride:   tenantData?.footer?.bgColor,
    footerTextOverride: tenantData?.footer?.textColor,

    headerMenu:      tenantData?.header,
    footerAboutText: tenantData?.footer?.aboutText,
    footerCopyright: tenantData?.footer?.copyright,

    heroData:        tenantData?.hero,
    aboutUs:         tenantData?.aboutUs,
    contactUs:       tenantData?.contactUs,
    destinations:    tenantData?.destinations,
    activeModules:   tenantData?.activeModules,

    metaTitle:       tenantData?.seo?.metaTitle,
    metaDescription: tenantData?.seo?.metaDescription,
  };
};

export const getB2CColors_T34 = (landingData) => {
  const coral    = landingData?.themeColor1 || landingData?.headerBgOverride;  // Vibrant Coral — primary CTA
  const navy     = landingData?.themeColor2 || '#1E3A5F';  // Deep Navy — dark elements
  const surface  = landingData?.themeColor3 || '#FFFFFF';  // Pure White — panels/cards
  const skyBlue  = landingData?.themeColor4 || '#00B4D8';  // Sky Blue — secondary accent
  const warmWhite = landingData?.themeColor5 || '#FFF8F2'; // Warm White — page background

  return {
    theme1: coral,
    theme2: landingData?.footerBgOverride || navy,
    theme3: landingData?.headerBgOverride || surface,
    theme4: skyBlue,
    theme5: warmWhite,

    headerText: landingData?.headerTextOverride || navy,
    footerText: landingData?.footerTextOverride || '#E8F4F8',

    topBarBg:   '#F0F8FF',
    topBarText: navy,
  };
};
